import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  CreateMembership,
  CreateMembershipSuccess,
  MembershipActionTypes,
  UpdateMembership,
  UpdateMembershipSuccess,
} from '@features/membership/store/actions/membership.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { CheckoutErrorDialogComponent } from '@rd/shared-legacy/components/checkout-error-dialog/checkout-error-dialog.component';
import { MembershipType } from '@rd/types';
import { tap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class AnzMembershipEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private dialogService: DialogService,
  ) {}

  createOrUpdateMembershipSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS,
          MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS,
        ),
        tap((action: UpdateMembershipSuccess | CreateMembershipSuccess) => {
          if (action.payload.type === MembershipType.PointsTransfer) {
            this.router.navigate(['/transfer/review'], {
              queryParams: {
                loyaltyProgramId: action.payload.loyaltyProgramId,
              },
            });
          }

          if (action.payload.type === MembershipType.CashBack) {
            this.router.navigate(['/redeem_cash/review'], {
              queryParams: {
                loyaltyProgramId: action.payload.loyaltyProgramId,
              },
            });
          }
        }),
      ),
    {
      dispatch: false,
    },
  );

  createMembershipError = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MembershipActionTypes.CREATE_MEMBERSHIP_FAIL),
        withLatestFrom(
          this.actions$.pipe(ofType(MembershipActionTypes.CREATE_MEMBERSHIP)),
        ),
        tap(([, action]: [any, CreateMembership]) => {
          if (action.payload.type === 'cashback_membership') {
            this.dialogService.open(CheckoutErrorDialogComponent, {
              data: {
                ctaButtonText: 'OK',
                errorMessageDescription:
                  "An error has occurred and we're unable to proceed your request.<br /> Please try again.",
                errorMessageTitle: 'Unexpected Error',
                iconName: 'warning',
              },
              id: 'rd-shared-checkout-error-dialog',
              screenMode: 'center-md',
            });
          }
        }),
      ),
    {
      dispatch: false,
    },
  );

  updateMembershipError = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MembershipActionTypes.UPDATE_MEMBERSHIP_FAIL),
        withLatestFrom(
          this.actions$.pipe(ofType(MembershipActionTypes.UPDATE_MEMBERSHIP)),
        ),
        tap(([, action]: [any, UpdateMembership]) => {
          console.log('update fail');
          if (
            action.payload.updateMembershipData.type === 'cashback_membership'
          ) {
            this.dialogService.open(CheckoutErrorDialogComponent, {
              data: {
                ctaButtonText: 'OK',
                errorMessageDescription:
                  "An error has occurred and we're unable to proceed your request.<br /> Please try again.",
                errorMessageTitle: 'Unexpected Error',
                iconName: 'warning',
              },
              id: 'rd-shared-checkout-error-dialog',
              screenMode: 'center-md',
            });
          }
        }),
      ),
    {
      dispatch: false,
    },
  );
}
